module.exports = __webpack_public_path__ + "img/symbol_0.d6cd5001.png";